import React, { useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { Link } from "react-router-dom";

import { getRecentRecipes } from "../../../../store/actions";
import PlaceholderIMG from "../../../../sharedComponents/placeholderImage";

const RecentRecipes = ({ recipeId, getRecentRecipes, recentRecipesResult }) => {
	useEffect(() => {
		getRecentRecipes(recipeId);
	}, [recipeId, getRecentRecipes]);

	const renderRecentRecipes = () => {
		return recentRecipesResult && recentRecipesResult.length ? (
			<div>
				<ul className="related-items-list">
					{recentRecipesResult.map(({ id, name, main_image }, index) => {
						return (
							<li key={index} className="related-items-item">
								<Link to={`/nutrition/recipes/${id}/details`}>
									<span className="related-items-item-image">
										<PlaceholderIMG
											src={main_image && main_image.photo_s}
											width="80"
											height="60"
											alt={name}
											bg="rgba(0,0,0,0.1)"
											color="rgba(0,0,0,0.3)"
											objectFit="cover"
										/>
									</span>
									<span className="related-items-item-name">{name}</span>
								</Link>
							</li>
						);
					})}
				</ul>
			</div>
		) : null;
	};

	return (
		<div className="recent-recipes-wrap">
			<h4 className="title-primary-dark">Recently Viewed</h4>
			{renderRecentRecipes()}
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		recentRecipesResult: get(state, "Recipes.recentRecipesResult", [])
	};
};

const mapDispatchToProps = { getRecentRecipes };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RecentRecipes);
